import * as React from "react";
import styled from "styled-components";
import DocsHelper from "util/DocsHelper";
import Icon from "../common/Icon";
const Container = styled.a`
  display: inline-flex;
  align-items: center;

  &:hover,
  &:focus {
    text-decoration: none;

    .documentation-link-text {
      text-decoration: underline;
    }
  }
`;
const StyledIcon = styled(Icon)`
  margin-left: 5px;
`;
const DocumentationLink = ({ page, title = "", text, displayIcon = false }) => /* @__PURE__ */ React.createElement(Container, { href: DocsHelper.toString(page), title, target: "_blank" }, /* @__PURE__ */ React.createElement("span", { className: "documentation-link-text" }, text), displayIcon && /* @__PURE__ */ React.createElement(StyledIcon, { name: "lightbulb_circle", type: "regular", size: "lg" }));
export default DocumentationLink;
